// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__HJOk3","title":"AfterBackImages_title__2Time","images":"AfterBackImages_images__1Y1mh"};